import React, { useState, useEffect, useContext } from 'react';
import Header from '../../components/Header';
import { db } from '../../services/firebaseConnection';
import { collection, getDocs, deleteDoc, doc, getDoc } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { FiEdit2, FiPlus } from 'react-icons/fi';
import { FaRegTrashAlt } from "react-icons/fa";
import { TbStarsFilled } from "react-icons/tb";
import { toast } from 'react-toastify';
import { AuthContext } from '../../contexts/auth';

export default function Cargo() {
  const [cargos, setCargos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'ascending' });
  const { user } = useContext(AuthContext);
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const getCargoFromDatabase = async () => {
      try {
        const cargoSnapshot = await getDocs(collection(db, 'Cargo'));
        const cargoData = cargoSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setCargos(cargoData);
        setLoading(false);
      } catch (error) {
        console.error('Erro ao buscar cargo:', error);
        setLoading(false);
      }
    };

    getCargoFromDatabase();
  }, []);

  useEffect(() => {
    async function loadPermissions() {

      const storedUser = localStorage.getItem('@userLogado');
      if (!storedUser) {
        console.error('Usuário não encontrado no localStorage.');
        return;
      }

      const userData = JSON.parse(storedUser);
      const cargoId = userData?.cargo;

      if (!cargoId) {
        console.error('ID do cargo não encontrado no usuário.');
        return;
      }

      try {

       
        const cargoRef = doc(db, 'Cargo', cargoId);
        const cargoDoc = await getDoc(cargoRef);

        if (cargoDoc.exists()) {
          const cargoData = cargoDoc.data();

          setPermissions(cargoData.permissoes || []);
        } else {
          console.error('Documento do cargo não encontrado no Firestore.');
        }
      } catch (error) {
        console.error('Erro ao buscar permissões no Firestore:', error);
      }
    }

    loadPermissions();
  }, []);

  const hasPermission = (permission) => {
    return permissions.includes(permission);
  };

  const handleDelete = async (id) => {
    try {
      const cargoRef = doc(db, 'Cargo', id);
      await deleteDoc(cargoRef);
      toast.success('Cargo excluída com sucesso!');
      setCargos(cargos.filter(cargo => cargo.id !== id));
    } catch (error) {
      console.error('Erro ao excluir cargo:', error);
      toast.error('Erro ao excluir cargo.');
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const sortedCargos = React.useMemo(() => {
    let sortableCargos = [...cargos];
    if (sortConfig.key) {
      sortableCargos.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableCargos;
  }, [cargos, sortConfig]);

  const filteredCargos = sortedCargos.filter(cargo =>
    cargo.nome.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <Header />

      <div className="content">
        <div className="title-container">
          <div className="title-left">
            <TbStarsFilled size={25} />
            <h1>Cargos</h1>
          </div>
          <Link to="/cargo/new" className="title-link incluir">
            <FiPlus color="#FFF" size={25} />
            <span>Incluir cargo</span>
          </Link>
        </div>

        <div className="container dashboard">
          {loading && <span>Carregando cargos...</span>}
          {!loading && cargos.length === 0 && <span>Nenhum cargo encontrado...</span>}
        </div>

        <input
          type="text"
          className="filter-container"
          placeholder="Buscar por nome..."
          value={searchTerm}
          onChange={handleSearchChange}
        />

        {!loading && cargos.length > 0 && (
          <table>
            <thead>
              <tr>
                <th onClick={() => handleSort('nome')}>Nome</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {filteredCargos.map((cargo, index) => (
                <tr key={index}>
                  <td data-label="Nome">{cargo.nome}</td>
                  <td data-label="Ação">
                    <Link to={`/cargo/edit/${cargo.id}`} className="action" style={{ backgroundColor: '#03c9e9' }}>
                      <FiEdit2 color='#FFF' size={17} />
                    </Link>
                    {hasPermission('deletar_itens') && (
                      <button
                        className="action"
                        style={{ backgroundColor: '#e90303' }}
                        onClick={() => handleDelete(cargo.id)}
                      >
                        <FaRegTrashAlt color="#FFF" size={17} />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
